<template>
  <div>
    <div class="loader-cont">
      <div class="loader-cont__wrapper">
        <div class="loader"></div>
        <div class="loader_text">{{ getTranslations.home_loader_please_wait }}</div>
      </div>
    </div>

    <maintenance v-if=serverUnderMaintenance></maintenance>
  </div>
</template>

<script>
/* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapGetters, mapMutations } from 'vuex';
import webSocket from '@/common/webSocket';
import auth from '@/common/auth';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import Maintenance from '@/components/home/modals/Maintenance';

export default {
  name: 'searching-opponent',
  props: ['gameType', 'gameMode'],
  mixins: [ParseResponseMixin, GameMixin2],
  components: {
    Maintenance,
  },
  watch: {
    stompClient: {
      handler() {
        console.log('change to stompclient!');
        // eslint-disable-next-line
        console.log('connected: ' + this.stompClient.connected);
        if (this.stompClient.connected) this.hasConnectAtLeastOneTime = true;
        else if (this.hasConnectAtLeastOneTime) this.OnStompClientFailure('lock screen error');
      },
      deep: true,
    },
  },
  data() {
    return {
      hasConnectAtLeastOneTime: false,
      stompClient: null,
      subscription: null,
      timer: null,
      connectionTimer: null,
      serverUnderMaintenance: false,
    };
  },
  created() {
    console.log('in SearchingOpponent created hook');
    // resetting game state
    this.resetGameState();
    this.setGameInProgress(true);
    this.setTransitionOnlyForSearchingToOpponent(true);
    this.callToInitiate();
    this.stompClient = webSocket.getGameStompClient();
    if (this.stompClient === null || !this.stompClient.connected) {
      this.stompClient = webSocket.createNewStompClient('/gameData');
    }
    console.log('this.stompClient:', this.stompClient);
    this.findOpponent();
  },
  beforeDestroy() {
    console.log('in searchingOpponent\'s beforeDestroy hook');
    // if for any reason we leave this component earlier from the websocket's response,
    // unsubscribe from the subscribed channels
    this.subscription = null;
  },
  methods: {
    ...mapMutations('game', [
      'setTransitionOnlyForSearchingToOpponent',
      'resetGameState',
      'setGameInProgress',
      'setGameID',
      'setMiniGames',
      'setGameType',
      'updateGameMode',
      'setTotalUserPoints',
      'setPointsPerMiniGame',
    ]),
    OnStompClientFailure(error) {
      console.log(error);
      window.location.reload();
    },
    callToInitiate() {
      return this.$axios({
        url: `api/randomMatchingForSwipo?gameTheme=${this.gameType}`,
        method: 'GET',
        headers: {
          Authorization: this.jwtInVuex,
        },
      }).then((response) => {
        const responseData = response.data;
        if (['SERVER_ERROR', 'NO_AVAILABLE_GAMES', 'EVENT_LOCKED'].includes(responseData.responseEnum)) {
          this.serverUnderMaintenance = true;
          this.showHideModal();
        }
      }).catch((error) => {
        console.log(`Invoking api/randomMatchingForBrainiac failed with the following error: ${error}`);
      });
    },
    findOpponent() {
      const stompSuccess = (frame) => {
        clearTimeout(this.connectionTimer);
        // console.clear();
        console.log(`In SearchingOpponent component: ${frame}`);
        console.log(`Subscribing to channel: /topic/ctasFetched/${this.userDetails.msisdn}`);
        this.subscription = this.stompClient.subscribe(`/topic/ctasFetched/${this.userDetails.msisdn}`, (response) => {
          console.log('[SearchingOpponent] Inside gameFound response');
          // parse server response and return if any errors occur
          const responseData = this.parseServerResponse(response.body);
          if (responseData === null || responseData === 'Maintenance') {
            this.serverUnderMaintenance = true;
            this.showHideModal();
          } else {
            this.subscription.unsubscribe();
            this.saveResponseData(responseData);
            this.normalTransition = true;
            console.log('going to opponent found page...');
            this.setGameType(this.gameType);
            this.updateGameMode(this.gameMode);
            this.defineNextRoute();
          }
        }, (errorResponse) => {
          console.error(`Error response: ${errorResponse}`);
        });
      };

      const stompFailure = (error) => {
        console.error(`Connect failed with the following error: ${error.headers.message}`);
        console.log(this.$router.currentRoute);
        if (this.$router.currentRoute.path === '/searchingOpponent') {
          console.info('Lost connection to WebSocket! Reconnecting in 3 seconds...');
          clearTimeout(this.connectionTimer);
          this.connectionTimer = setTimeout(() => {
            this.stompClient = webSocket.createNewStompClient('/gameData');
            connect();
          }, 3000);
        }
      };

      const connect = (() => {
        if (!this.stompClient.connected) {
          this.stompClient.connect({ Authorization: auth.getJwt() }, stompSuccess, stompFailure);
        } else {
          stompSuccess();
        }
      })();
    },
    saveResponseData(responseData) {
      this.setGameID(responseData.id);
      this.setMiniGames(responseData.miniGames);
      this.setTotalUserPoints(responseData.userPoints);
      this.setPointsPerMiniGame(responseData.pointsPerMiniGame);
    },
    showHideModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          $('.modal, .modal-overlay').fadeOut();
          this.setGameInProgress(false);
          this.setTransitionOnlyForSearchingToOpponent(false);
          this.$router.push('/home');
        });

        $('.modal,.modal-overlay').fadeIn(200);
        /* eslint-enable */
      });
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('game', [
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/SearchingOpponent.vue